@if (store.goalData(); as goalData) {
<div class="goal-page" [class.astrazeneca]="isAstraZeneca()">
  <div class="goal-page-hero">
    <div class="goal-page-media">
      @if(isAstraZeneca()){
      <div class="astrazeneca-img">
        <img src="assets/AstraZenecaMSD.jpeg" alt="" />
      </div>
      } @else {
      <video #goalVideo aria-hidden="true" [poster]="videoPosterUrl" [src]="videoUrl"
        (canplay)="playHeroVideo(goalVideo)" autoplay loop muted playsinline></video>
      }
    </div>
    <div class="goal-page-content">
      <app-goal-header class="header" [goalData]="goalData" />
    </div>
  </div>

  <div class="goal-page-content goal-page-activities-shell">
    <app-goal-activities-section class="goal-page-activities" [activities]="store.visibleActivities()"
      [areActivitiesExpanded]="store.areActivitiesExpanded()" [isLoading]="store.isLoading()"
      [shouldShowToggle]="store.shouldShowActivitiesToggle()" [paginationMeta]="store.paginationMeta()"
      (toggleExpansion)="goalPage.toggleActivitiesExpansion()" (activitiesPageChange)="setActivitiesPage($event)" />
  </div>

  <app-toolbar-dock iconColor="dark">
    <app-toolbar-goal></app-toolbar-goal>
  </app-toolbar-dock>
</div>
} @else if (store.isLoading()) {
<div class="goal-page-state" aria-live="polite">
  <kin-pulse-loader />
</div>
} @else if (store.error()) {
<app-error-state [errorCode]="store.goalErrorCode()" />
}